import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { IconIcon } from "components/common/Icons/IconIcon";
import { SpaceIcon } from "components/common/Icons/SpaceIcon";
import { TextIcon } from "components/common/Icons/TextIcon";
import { UploadIcon } from "components/common/Icons/UploadIcon";
import type { ReactNode } from "react";
import { useMemeDeviceUpload } from "../../LeftBar/Buttons/useMemeDeviceUpload";
import type { ActiveType } from "../useBottomMenu";
import { useOptions } from "./useOptions";

export interface OptionsProps {
    openPopup: (activeType: ActiveType) => void;
}

export const Options = ({ openPopup }: OptionsProps) => {
    const { handleAddTextBox } = useOptions();
    const { handleMemeDeviceUpload } = useMemeDeviceUpload();
    return (
        <div className="w-full grid grid-cols-4 border-t border-t-irGray-200 dark:border-t-darkSurface-600 dark:bg-border bg-white dark:bg-darkSurface-100">
            <Block icon={<TextIcon />} text={capitalize(translateFunc("text"))} onClick={handleAddTextBox} />
            <Block icon={<IconIcon />} text={capitalize(translateFunc("icon"))} onClick={() => openPopup("icon")} />
            <Block
                icon={<SpaceIcon />}
                text={capitalize(translateFunc("padding"))}
                onClick={() => openPopup("padding")}
            />
            <Block
                icon={<UploadIcon fill={"black"} />}
                text={capitalize(translateFunc("upload"))}
                onClick={handleMemeDeviceUpload}
            />
        </div>
    );
};

interface BlockProps {
    icon: ReactNode;
    text: string;
    onClick: () => void;
}

const Block = ({ icon, text, onClick }: BlockProps) => {
    return (
        <button
            className="h-full w-full flex flex-col items-center justify-center text-[13px] py-2 text-black dark:text-white"
            onClick={onClick}
        >
            <div>{icon}</div>
            <div>{text}</div>
        </button>
    );
};
